import classNames from 'classnames';
import * as React from 'react';

import { WidthVariant } from '../../../WidthVariant.csharp';
import { CircleInfo } from './CircleInfo/CircleInfo';
import { CircleInfoViewModel } from './CircleInfo/CircleInfoViewModel.csharp';
import { FeaturedInfo } from './FeaturedInfo/FeaturedInfo';
import { FeaturedInfoViewModel } from './FeaturedInfo/FeaturedInfoViewModel.csharp';
import { FeaturedProductsCompatibleBlockType } from './FeaturedProductsCompatibleBlockType.csharp';
import { IFeaturedProductsCompatibleBlockViewModel } from './IFeaturedProductsCompatibleBlockViewModel.csharp';

export const FeaturedProductsCompatibleBlock = ({ model }: { model: IFeaturedProductsCompatibleBlockViewModel }) => {
    const renderCompatibleBlock = (widthVariant: WidthVariant, child: JSX.Element) => {
        return <div className={classNames('FeaturedProductsCompatibleBlock', `FeaturedProductsCompatibleBlock--${WidthVariant[widthVariant]}`)}>{child}</div>;
    };

    switch (model.type) {
        case FeaturedProductsCompatibleBlockType.CircleInfo:
            return renderCompatibleBlock(WidthVariant.TwoColumn, <CircleInfo model={model as CircleInfoViewModel} />);
        case FeaturedProductsCompatibleBlockType.FeaturedInfo: {
            const blockModel = model as FeaturedInfoViewModel;
            return renderCompatibleBlock(blockModel.layout, <FeaturedInfo model={blockModel} />);
        }
    }
};
